var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoardFooterButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60938 2V14.0519C3.60938 14.6042 3.16166 15.0519 2.60938 15.0519C2.05709 15.0519 1.60938 14.6042 1.60938 14.0519V1.87013C1.60938 1.39829 1.78198 0.931553 2.11086 0.575915C2.44216 0.217643 2.90903 0 3.41402 0H21.1162C21.6211 0 22.088 0.217642 22.4193 0.575915C22.7482 0.931555 22.9208 1.39829 22.9208 1.87013V14.0519C22.9208 14.6042 22.4731 15.0519 21.9208 15.0519C21.3685 15.0519 20.9208 14.6042 20.9208 14.0519V2H3.60938Z",
    fill: "#127050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.5322C0 16.9799 0.447715 16.5322 1 16.5322H23.53C24.0823 16.5322 24.53 16.9799 24.53 17.5322C24.53 18.0845 24.0823 18.5322 23.53 18.5322H1C0.447715 18.5322 0 18.0845 0 17.5322Z",
    fill: "#127050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4609 14.0522C10.4609 13.5 10.9087 13.0522 11.4609 13.0522H17.8981C18.4504 13.0522 18.8981 13.5 18.8981 14.0522V17.5328C18.8981 18.085 18.4504 18.5328 17.8981 18.5328C17.3458 18.5328 16.8981 18.085 16.8981 17.5328V15.0522H12.4609V17.5328C12.4609 18.085 12.0132 18.5328 11.4609 18.5328C10.9087 18.5328 10.4609 18.085 10.4609 17.5328V14.0522Z",
    fill: "#127050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardFooterButton);
export default __webpack_public_path__ + "static/media/board-footer-button.5a2563787658d16261c7c74c9338b360.svg";
export { ForwardRef as ReactComponent };